'use client'

import Typography from '@mui/material/Typography'
import { FC, PropsWithChildren } from 'react'
import mlEmployeesCollaborating from '../../../../public/assets/ml-employees-collaborating.png'
import ImageFirstSection from '../ImageFirstSection'

const JoinUsSection: FC<PropsWithChildren> = ({ children }) => (
  <ImageFirstSection
    imageSrc={mlEmployeesCollaborating}
    imageAltText="Mission Lane employees collaborating"
  >
    <div className="flex flex-col gap-4 md:gap-6">
      <Typography variant="h2">Join us</Typography>
      <Typography variant="p1">
        Our commitment to a workplace built on respect and dignity is guided by our core value of
        Unity. We actively cultivate an environment where all individuals have the opportunity to do
        their best work. If you&apos;re looking for a place where your voice matters and your work
        has purpose, we invite you to explore our open roles.
      </Typography>
      {children}
    </div>
  </ImageFirstSection>
)

export default JoinUsSection
